import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Loader2, KeyRound, X } from "lucide-react";
import { toast } from "sonner";

export const ResetPasswordDialog = ({ member, onClose, onDone }) => {
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post(`/my/loyalty/members/${member.id}/reset-password`, { password });
      toast.success("Password reset. Share it with the customer.");
      onDone();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[70] bg-black/70 flex items-center justify-center p-4" onClick={onClose}>
      <form data-testid="reset-password-dialog" onSubmit={submit} className="bg-slate-900 border border-slate-800 rounded-2xl w-full max-w-sm p-6 space-y-4 fade-up" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between">
          <h3 className="font-heading text-xl font-bold">Reset password</h3>
          <button type="button" data-testid="reset-password-close" onClick={onClose} className="text-slate-400 hover:text-white"><X className="h-5 w-5" /></button>
        </div>
        <p className="text-sm text-slate-400">Set a new login password for <b className="text-white">{member.name || member.phone}</b> ({member.phone}).</p>
        <input data-testid="reset-password-input" type="text" autoFocus required minLength={4} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="New password (min 4 characters)" className="w-full bg-slate-800 border border-slate-700 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-orange-500" />
        <div className="grid grid-cols-2 gap-2">
          <button type="button" data-testid="reset-password-cancel" onClick={onClose} className="rounded-xl py-3 font-semibold bg-slate-800 hover:bg-slate-700 transition-colors">Cancel</button>
          <button type="submit" data-testid="reset-password-confirm" disabled={busy || password.length < 4} className="inline-flex items-center justify-center gap-2 rounded-xl py-3 font-semibold bg-orange-600 hover:bg-orange-700 disabled:opacity-60 transition-colors">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <KeyRound className="h-4 w-4" />} Reset
          </button>
        </div>
      </form>
    </div>
  );
};
